import React from 'react';
import { useTheme } from '../context/ThemeContext';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = ({ className = '' }) => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className={`relative inline-flex h-9 w-16 items-center rounded-full transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 ${
        isDark ? 'bg-gray-700' : 'bg-gray-200'
      } ${className}`}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      data-testid="theme-toggle"
    >
      {/* Track icons */}
      <span className="absolute left-1.5 flex items-center justify-center">
        <Moon className={`h-4 w-4 transition-opacity ${isDark ? 'text-yellow-300 opacity-100' : 'text-gray-400 opacity-40'}`} />
      </span>
      <span className="absolute right-1.5 flex items-center justify-center">
        <Sun className={`h-4 w-4 transition-opacity ${isDark ? 'text-gray-500 opacity-40' : 'text-yellow-500 opacity-100'}`} />
      </span>
      
      {/* Sliding thumb */}
      <span
        className={`inline-block h-7 w-7 transform rounded-full bg-white shadow-lg transition-transform duration-300 ${
          isDark ? 'translate-x-1' : 'translate-x-8'
        }`}
      />
    </button>
  );
};

export default ThemeToggle;
